// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.10";globalThis["_sentryRewritesTunnelPath"] = "/client/monitoring";import * as Sentry from "@sentry/nextjs";
import {
  sentryBeforeSend,
  sentryBeforeSendTransaction,
} from "@repo/common/lib/sentry-graphql-fingerprint";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  normalizeDepth: 4, // lets us log more of the error under "extra"
  sendDefaultPii: false,
  environment: process.env.NEXT_PUBLIC_ENV,
  initialScope: {
    tags: process.env.NEXT_PUBLIC_APP_VERSION
      ? { appVersion: process.env.NEXT_PUBLIC_APP_VERSION }
      : {},
  },
  ignoreErrors: [
    "Can't find variable: __firefox__",
    "Can't find variable: __firefox",
    "ReferenceError: Can't find variable: __firefox__",
    "ReferenceError: Can't find variable: __firefox",
    "TypeError: undefined is not an object (evaluating 'window.__firefox__",
    "TypeError: undefined is not an object (evaluating '__firefox__",
    "Error: Missing authorization header or cookie",
  ],
  beforeSend: sentryBeforeSend,
  beforeSendTransaction: sentryBeforeSendTransaction,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
